<div class="link-complete">
  <img class="logo" alt="Calingo" src="assets/calingo-logo-green.svg"/>

  <h1 class="title">{{ 'auth.link-complete.title' | translate }}</h1>

  @if (!failed) {
    <p class="message">
      {{ (email ? 'auth.link-complete.signing-in' : 'auth.link-complete.signing-in-no-email')
      | translate: { email: email } }}
    </p>
  }

  @if (failed) {
    <p class="message error">{{ 'auth.link-complete.error' | translate }}</p>
    <a class="back button link text-button-12" routerLink="/auth">
      {{ 'auth.link-complete.back' | translate }}
    </a>
  }
</div>
